import { z } from "zod";

export const listingContactGapSchema = z.enum([
    "fee",
    "goodWith",
    "spay",
    "meeting",
]);

export type ListingContactGap = z.infer<typeof listingContactGapSchema>;

export const listingContactHelpEventSchema = z.discriminatedUnion("event", [
    z
        .object({
            event: z.literal("listing_contact_help_viewed"),
            dogId: z.string().min(1),
            arm: z.enum(["control", "reassurance", "facts"]),
            surface: z.enum(["desktop", "mobile"]),
        })
        .strict(),
    z
        .object({
            event: z.literal("listing_contact_help_gap_toggled"),
            dogId: z.string().min(1),
            arm: z.literal("facts"),
            gap: listingContactGapSchema,
            selected: z.boolean(),
            surface: z.enum(["desktop", "mobile"]),
        })
        .strict(),
]);

export type ListingContactHelpEvent = z.infer<
    typeof listingContactHelpEventSchema
>;
